import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreviewQRCode from "components/Common/ModalPreviewQRCode";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_STATUS_ACTIVE_DISABLE,
  LIST_USER_PLAN_STATUS,
  PLAN_TYPE_OPTION,
  PLAN_FEATURE_KEY_OPTION,
  STATUS_ACTIVE_DISABLE_OPTION,
  LIST_PLAN_PRICE_TYPE,
  COLOR_PLAN_PRICE_TYPE,
} from "helpers/constans";
import { checkHasAllOption, formatDateStringToKorea, formatDateStringToUTC, formatNumber } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  ArrayParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import PlanForm from "./PlanForm";
import { getPlans, updatePlan } from "store/plans/thunk";
import { useSelector } from "react-redux";
import DropdownOptionMulti from "components/Common/DropdownOptionMulti";
import CountUp from "react-countup";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import plansApi from "api/planApi";

interface Option {
  label: string;
  value: string;
}

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const PlanManagement = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    planCode: withDefault(StringParam, ""),
    planName: withDefault(StringParam, ""),
    planFeatures: withDefault(ArrayParam, null),
    isActive: withDefault(StringParam, ""),
    createdFrom: withDefault(StringParam, ""),
    createdTo: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, "createdAt"),
    // orderBy: withDefault(StringParam, "desc"),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMultiPlanFeature, setIsMultiPlanFeature] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [previewQRCode, setPreviewQRCode] = useState<any>(null);

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.createdFrom
      ? moment(query?.createdFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.createdTo ? moment(query?.createdTo || "", "Y-MM-DD").toDate() : null,
  ]);
  const [createdFrom, createdTo] = dateSearch;

  const [planCode, setPlanCodeSearch] = useState<string>(query?.planCode || "");

  const [planName, setPlanNameSearch] = useState<string>(query?.planName || "");

  const [planTypeSearch, setPlanTypeSearch] = useState<Option | any>(
    PLAN_TYPE_OPTION?.find(
      (item) => String(item?.value) === String(query?.planTypes)
    )?.value || ""
  );
  const [planFeatureSearch, setPlanFeatureSearch] = useState<Option | any>(
    PLAN_FEATURE_KEY_OPTION?.find(
      (item) => String(item?.value) === String(query?.planFeatures)
    )?.value || ""
  );

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_USER_PLAN_STATUS?.find((item) => item?.value === query?.isActive)
      ?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Plan;

  const PlanProperties = createSelector(
    selectLayoutState,
    (state) => ({
      plans: state?.plans,
      isPlanLoading: state?.isPlanLoading,
      isPlanSuccess: state?.isPlanSuccess,
      error: state?.error,
    })
  );

  // Inside your component
  const { plans, isPlanLoading } = useSelector(PlanProperties);

  function loadTableData() {
    dispatch(getPlans(query));
  }

  const searchData = () => {
    const formatPlanFeatureData = planFeatureSearch?.length > 0 ? planFeatureSearch?.map((item: any) => (item?.value)) : ((planFeatureSearch?.value && planFeatureSearch?.value !== "all") ? [planFeatureSearch?.value] : []);
    setQuery({
      ...query,
      planCode: planCode,
      planName: planName,
      planFeatures: formatPlanFeatureData,
      isActive: statusSearch,
      createdFrom: createdFrom
        ? formatDateStringToUTC(
          moment(new Date(createdFrom))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      createdTo: createdTo
        ? formatDateStringToUTC(
          moment(new Date(createdTo)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        planCode: "",
        planName: "",
        planTypes: "",
        planFeatures: [],
        isActive: "",
        createdFrom: "",
        createdTo: "",
        sortBy: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setPlanCodeSearch((_prev) => "");
    setPlanNameSearch((_prev) => "");
    setPlanTypeSearch((_prev: any) => "");
    setPlanFeatureSearch((_prev: any) => []);
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  // Begin::Change status
  const [isLoadingUpdate, setIsLoadingUpdate] = useState<boolean>(false);

  const handleOnConfirmUpdate = async (item: {
    data: any;
    isActive: string | boolean;
  }) => {
    if (!item || !item?.data?.id) return;

    try {
      // console.log(item?.data)
      const formatData = {
        code: item?.data?.code || "",
        name: item?.data?.info?.name || "",
        price: item?.data?.price?.price || 0,
        vatRate: item?.data?.price?.vatRate || 0,
        discountRate: Number(item?.data?.price?.discountRate) || 0,
        priceFinal: Number(item?.data?.price?.priceFinal) || 0,
        currency: item?.data?.price?.currency || "KRW",
        features: item?.data?.features,
        priceType: item?.data?.priceType,
        description: item?.data?.info?.description,
        isActive: item?.isActive
      }
      // console.log(formatData)
      const response: any = await updatePlan(item?.data?.id, formatData);
      if (response?.code === 200) {
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingUpdate((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // End::Change status

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper
              contentCopy={item?.id || ""}
              style={{ display: "inline-flex", minWidth: "50px" }}
            >
              <div>
                {plans?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "isActive",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
              style={{ minWidth: "80px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value === true}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    data: item,
                    isActive: value,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Plan Code"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer" style={{ minWidth: "150px" }}>
              {
                cell?.value ? (
                  <CopyWrapper contentCopy={cell?.value}>
                    {`${cell?.value}`}
                  </CopyWrapper>
                ) : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Plan Name"),
        accessor: "info.name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          
          return (
            <div className="cursor-pointer" style={{ minWidth: "180px" }}>
              {
                cell?.value ? (
                  <div 
                    className="cursor-pointer text-primary"
                    onClick={() => {
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                    >
                    <CopyWrapper contentCopy={cell?.value}>
                      {`${cell?.value}`}
                    </CopyWrapper>
                  </div>
                ) : "-"
              }
            </div>
          );
        },
      },

      {
        Header: t("Plan Feature"),
        accessor: "features",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer d-flex gap-2" style={{ minWidth: "180px" }}>
              {cell?.value
                ? cell?.value?.map((feature: any, index: number) => (
                  <span
                    className={`rounded-pill badge bg-primary`}
                    key={index}
                  >
                    {t(
                      PLAN_FEATURE_KEY_OPTION?.find(
                        (item: any) => String(item?.value) === String(feature?.key)
                      )?.label || ""
                    )}
                  </span>
                ))
                : "-"}
            </div>
          );
        },
      },

      {
        Header: t("Description"),
        accessor: "info.description",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 250,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer" style={{ minWidth: "200px" }}>
              {
                cell?.value ? (
                  <CopyWrapper contentCopy={cell?.value}>
                    {`${cell?.value}`}
                  </CopyWrapper>
                ) : "-"
              }
            </div>
          );
        },
      },

      {
        Header: t("Price Type"),
        accessor: "priceType",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-center",
        thWidth: 100,
        Cell: (cell: any) => {
          return cell?.value ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_PLAN_PRICE_TYPE[cell?.value] || "secondary"
                  }`}
              >
                {t(
                  LIST_PLAN_PRICE_TYPE.filter(
                    (i: any) => i?.value == cell?.value
                  )[0]?.label
                )}
              </span>
            </div>
          ) : "-";
        },
      },

      {
        Header: t("Price"),
        accessor: "price",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 200,
        Cell: (cell: any) => {
          const item = cell?.value;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const price = item?.price;
          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {price ? `${formatNumber(price)} ${currency}` : "-"}
              </div>
            </>
          );
        },
      },

      {
        Header: `${t("Discount Rate")} (%)`,
        accessor: "price.discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const discountRate = cell?.value;
          const priceType = cell?.row?.original?.priceType;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(discountRate && priceType !== "FREE") ? `${formatNumber(discountRate)}%` : "-"}
              </div>
            </>
          );
        },
      },

      {
        Header: t("Final Price"),
        accessor: "price.priceFinal",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.price;
          const priceType = cell?.row?.original?.priceType;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const priceFinal = item?.priceFinal;
          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(priceFinal && priceType !== "FREE") ? `${formatNumber(priceFinal)} ${currency}` : "-"}
              </div>
            </>
          );
        },
      },

      {
        Header: t("VAT (%)"),
        accessor: "price.vatRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 100,
        Cell: (cell: any) => {
          const priceType = cell?.row?.original?.priceType;
          
          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "90px" }}>
                {(priceType !== "FREE") ? `${formatNumber(cell?.value)}%` : "-"}
              </div>
            </>
          );
        },
      },

      {
        Header: t("Created At"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-nowrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToEdit(item);
                    setIsOpen(true);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, plans?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseQRCodeClick = () => {
    setPreviewQRCode(null);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await plansApi.deletePlan(id);
      if (response?.code) {
        setIsConfirmLoading((_prev) => false);
        dispatch(getPlans(query));
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Plan Menu")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Plan Menu")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={plans?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-7 con-sm-6 text-end">
                      {isHavePermissionRole(
                        ROLES_FOR_APP.PLAN_MANAGEMENT_CREATE,
                        userPermissions
                      ) && (
                          <div className="col-sm-auto">
                            <div>
                              <button
                                type="button"
                                className="btn btn-success add-btn"
                                onClick={() => {
                                  setIsOpen(true);
                                  setItemToEdit(null);
                                }}
                              >
                                <i className="ri-add-line align-bottom me-1"></i>
                                {t("Create Plan")}
                              </button>
                            </div>
                          </div>
                        )}
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Plan Code")}
                          isShow={!!planCode}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Plan Code")}...`}
                            value={planCode}
                            onChange={(e) => setPlanCodeSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Plan Name")}
                          isShow={!!planName}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Plan Name")}...`}
                            value={planName}
                            onChange={(e) => setPlanNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Plan Feature")} isShow={true}>
                          <DropdownOptionMulti
                            name="plan-feature"
                            isMulti={isMultiPlanFeature}
                            dataList={PLAN_FEATURE_KEY_OPTION || []}
                            placeholder={`${t("Select plan feature")}...`}
                            initialValue={planFeatureSearch}
                            // onChangeSelect={(e: any) => setPlanFeatureSearch(e)}
                            onChangeSelect={(e: any) => {
                              if (e?.length === 0 || e?.value === 'all') {
                                setIsMultiPlanFeature(false)
                                setPlanFeatureSearch({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                              } else {
                                setPlanFeatureSearch(e)
                                setIsMultiPlanFeature(checkHasAllOption(e) ? false : true)
                              }
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "all" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!createdFrom || !!createdTo}
                        >
                          <DatePickerCustom
                            startDate={createdFrom || null}
                            endDate={createdTo || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={plans?.items?.length ? plans?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={plans?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(plans?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isPlanLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <PlanForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
          />
        )}

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete This Plan")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {previewQRCode && (
          <ModalPreviewQRCode
            data={previewQRCode}
            title={""}
            onCloseQRCodeClick={onCloseQRCodeClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default PlanManagement;
